<template>
    <div>
        <!-- Real estate search -->
        <div class="mx-auto max-w-[1200px]">
            <!-- gap-3 -->
            <form :action="this.$route('web.search')" method="GET">
                <div
                    class="mx-auto flex w-full flex-col items-center rounded-full bg-white text-sm text-black-78 shadow-search md:flex-row"
                >
                    <div class="w-full md:w-3/4">
                        <div class="relative flex items-center">
                            <label
                                for="location"
                                class="absolute left-0 top-0 flex h-full w-full cursor-pointer items-center rounded-full py-5 font-medium text-black-50 hover:bg-green-10 md:px-10"
                                v-if="
                                    !hideLocationLabel &&
                                    locationOption === null
                                "
                                @click="openLocation"
                            >
                                <div
                                    class="overflow-hidden text-ellipsis whitespace-nowrap"
                                >
                                    <span class="text-black-78">Lokacija:</span>
                                    mesto, ulica, poštna št.
                                </div>
                            </label>
                            <v-select
                                class="w-full font-medium"
                                :options="locations"
                                placeholder=""
                                v-model="locationOption"
                                label="custom_label"
                                @open="onOpen"
                                @search:focus="onFocus"
                                @search:blur="onBlur"
                                ref="location"
                                id="location"
                                :name="'location'"
                            >
                                <template v-slot:no-options>
                                    Za ta iskalni niz ni zadetkov.
                                </template>
                            </v-select>
                            <input
                                type="hidden"
                                name="location"
                                :value="
                                    locationOption == null
                                        ? ''
                                        : locationOption.value
                                "
                            />

                            <!-- Error state -->
                            <div
                                v-if="errors.location"
                                class="absolute left-5 top-full -z-10 whitespace-nowrap rounded-b-xl bg-salmon px-5 py-2.5 text-xs font-medium leading-none text-white lg:left-1/2 lg:-translate-x-1/2"
                            >
                                <div class="flex items-center">
                                    <v-icon
                                        icon="x-circle"
                                        size="3.5"
                                        class="mr-1.5 text-white"
                                    ></v-icon>
                                    Prosimo vnesite lokacijo.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full md:w-1/4">
                        <v-main-search-dropdown
                            :placeholder="rentOrBuyPlaceholder.label"
                            :icon="rentOrBuyPlaceholder.icon"
                            ref="rentOrBuyDropdown"
                        >
                            <template v-slot:options>
                                <div class="grid grid-cols-2 gap-5">
                                    <div
                                        v-for="(
                                            option, index
                                        ) in rentOrBuyOptions"
                                        v-bind:key="'rent_or_buy' + index"
                                    >
                                        <v-form-radio
                                            name="rent_or_buy"
                                            :id="'rent_or_buy_' + index"
                                            :label="option.label"
                                            :value="option.value"
                                            v-model="rentOrBuyValue"
                                            :fixed-height="true"
                                        >
                                            <template v-slot:icon>
                                                <v-icon
                                                    :icon="option.icon"
                                                    size="5"
                                                    class="mr-2"
                                                ></v-icon>
                                            </template>
                                        </v-form-radio>
                                    </div>
                                </div>
                            </template>
                        </v-main-search-dropdown>
                    </div>
                    <div class="pr-2.5">
                        <button
                            class="flex items-center justify-center gap-[10px] rounded-full bg-green px-[15px] py-3 text-body-medium-button text-white hover:bg-green-hover"
                            type="submit"
                        >
                            <v-icon icon="loupe" size="5" class=""></v-icon>
                            <label class="pointer-events-none">Iščite</label>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import MainSearchDropdown from "./MainSearchDropdown.vue";

export default {
    name: "MainSearchRealEstateDesktop",

    components: {
        "v-main-search-dropdown": MainSearchDropdown,
    },

    props: {
        i18n: {
            type: Object,
            required: true,
        },
        enums: {
            type: Object,
            required: true,
        },
        rentOrBuyOptions: {
            type: Object,
            required: true,
        },
        locations: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {
            locationOption: null,
            hideLocationLabel: false,
            rentOrBuyValue: "miete",
            realestateTypeValue: "",
            minPrice: "",
            maxPrice: "",
        };
    },
    mounted() {},
    computed: {
        rentOrBuyPlaceholder() {
            this.$refs.rentOrBuyDropdown
                ? (this.$refs.rentOrBuyDropdown.show = false)
                : null;

            return this.rentOrBuyOptions.find(
                (option) => option.value === this.rentOrBuyValue
            );
        },
    },
    methods: {
        onOpen() {},
        openLocation() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.location;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        onFocus() {
            this.hideLocationLabel = true;
        },
        onBlur() {
            this.hideLocationLabel = false;
        },
    },
};
</script>
